<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body" class="responsive">
  <BackgroundImage />

    <div id="wrapper">
      <div id="head-logo">
        <router-link to="/pc/login" target="_blank">
          <img src="/lc/app/images/log-1row.svg" alt="LEGAL CONNECTION">
        </router-link>
      </div>
      <!-- content:start -->
      <div id="content">
        <div class="contact">
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link">無料トライアルの申し込み</span>
              <span class="breadcrumb-link">無料トライアルの登録</span>
              <span class="breadcrumb-link current">無料トライアルの登録の確認</span>
              <span class="breadcrumb-link">無料トライアルの登録の完了</span>
            </div>
            <h1 class="hdg02">無料トライアルの登録の確認</h1>
            <a href="/lc/about/" target="_blank" class="contact-head-link">LEGAL CONNECTIONについて <FontawesomeIcon icon="external-link-alt" class="icn" /></a>
          </div>
          <form @submit.prevent class="contact-container">
            <div class="contact-content">
              <p class="txt mb40">下記内容で無料トライアル登録を確定します。</p>
              <h2 class="hdg03 mb32">登録内容</h2>
              <ul class="contact-content-list">
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          法人名/個人名 
                        </th>
                        <td>
                          {{ group1.name }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          読み仮名 
                        </th>
                        <td>
                          {{ group1.kana }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          ご担当者名 
                        </th>
                        <td>
                          {{ group1.charge_name }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          ご担当部署名 
                        </th>
                        <td>
                          {{ group1.department }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          郵便番号/住所  
                        </th>
                        <td>
                          〒 {{ group1.postnumber }}<br>
                          {{ group1.address }}{{ group1.address2 }}{{ group1.address3 }}<br>
                          {{ group1.address4 }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          メールアドレス 
                        </th>
                        <td>
                          {{ group1.email }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          職業  
                        </th>
                        <td>
                          {{ group1.selectedOccupationClassificationName }}<br>
                          {{ group1.selectedOccupationName }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          電話番号1 
                        </th>
                        <td>
                          {{ group1.tel }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          電話番号2
                        </th>
                        <td>
                          {{ group1.tel2 }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          内線番号
                        </th>
                        <td>
                          {{ group1.extension }}
                        </td>
                      </tr>
                      <tr>
                        <th>
                          FAX番号
                        </th>
                        <td>
                          {{ group1.fax }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          弊社紹介社員
                        </th>
                        <td>
                          {{ group1.introducer }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>
                          備考
                        </th>
                        <td v-html="group1.noteDisp"></td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>

              <h2 class="hdg03 mb20">無料トライアルを希望するパッケージ</h2>
              <!-- PCの場合 -->
              <div class="visible-pc">
                <div v-for="(item, index) in group1.productsLicensesDisp" :key="'package_' + index" class="tbl04 box-package">
                  <div class="tbl04-hdgarea">
                    <h3 class="hdg03 mb20">{{ item.package_name }}</h3>
                    <p class="txt mb0">お申し込みいただいたライセンスは、本日から{{ item.period_end }} までご利用いただけます。</p>
                  </div>
                  <div class="tbl04-bodyarea">
                    <table class="tbl04-table">
                      <colgroup>
                        <col style="width:40%;">
                        <col sytle="width:20%;">
                        <col sytle="width:20%;">
                        <col sytle="width:20%;">
                      </colgroup>
                      <thead>
                        <tr>
                          <th></th>
                          <th>申込ライセンス数</th>
                          <th>ライセンス期限</th>
                          <th>価格（税込）</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item2, index2) in item.basic_products" :key="'basic_' + index2">
                          <th>
                            <div class="tbl04-table-txt">{{ item2.name }}</div>
                          </th>
                          <td>
                            <div class="tbl04-table-txt">{{ item2.license_number }}</div>
                          </td>
                          <td>
                            <div class="tbl04-table-txt">{{ item2.period_expression }}</div>
                            <div class="tbl04-table-txt-sub">（{{ item2.period_start }} ~ {{ item2.period_end }}）</div>
                          </td>
                          <td>
                            <div class="tbl04-table-txt">無料</div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <!-- SPの場合 -->
              <div class="visible-sp">
                <div v-for="(item, index) in group1.productsLicensesDisp" :key="'package_' + index" class="tbl04">
                  <div class="tbl04-hdgarea">
                    <h3 class="hdg03 mb20">{{ item.package_name }}</h3>
                    <p class="txt mb0">お申し込みいただいたライセンスは、本日から{{ item.period_end }} までご利用いただけます。</p>
                  </div>
                  <div class="tbl04-bodyarea">
                    <table class="tbl04-table">
                      <tr v-for="(item2, index2) in item.basic_products" :key="'basic_' + index2">
                        <td>
                          <div class="tbl04-table-txt">{{ item2.name }}</div>
                        </td>
                        <th>申込ライセンス数</th>
                        <td>
                          <div class="tbl04-table-txt">{{ item2.license_number }}</div>
                        </td>
                        <th>ライセンス期限</th>
                        <td>
                          <div class="tbl04-table-txt">{{ item2.period_expression }}</div>
                          <div class="tbl04-table-txt-sub">（{{ item2.period_start }} ~ {{ item2.period_end }}）</div>
                        </td>
                        <th>価格（税込）</th>
                        <td>
                          <div class="tbl04-table-txt">無料</div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <div class="contact-submit">
                <router-link to="/public/trial-registration/index" class="contact-submit-link">
                  <FontawesomeIcon :icon="['fas','angle-left']" class="icn" />
                  戻る
                </router-link>
                <div class="button contact-submit-button">
                  <button class="btn" @click="group1.onSubmitButtonClicked">確定</button>
                </div>
              </div>

            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
// import '@/components/style/RESCommonCSS.vue'
import * as logicTrialRegistration from '@/logic/public/TrialRegistration'

export default defineComponent({
  components: {
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicTrialRegistration.getGroupConfirm()

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.contact-submit{
  margin-top: 30px;
}
</style>
